import * as React from 'react';
import Breadcrumb from '@/components/display/headers/Breadcrumb';
import Podcast from '@/types/pages/api/podcasts/Podcast';
import SitemapContainer from '@/components/pages/sitemap/components/SitemapContainer';
import { Category } from '@/utils/functions/wordpress/fetchCategories';
import SitemapListItem from '@/components/pages/sitemap/components/SitemapListItem';

type SitemapPageLayoutProps = {
    podcasts: Podcast[];
    categories: Category[];
};

const SitemapPageLayout = (props: SitemapPageLayoutProps) => {
    const { podcasts, categories } = props;

    const sections = [
        {
            title: 'News',
            link: '/news',
        },
        {
            title: 'Newsletters',
            link: '/newsletter',
        },
        {
            title: 'Podcasts',
            link: '/podcasts',
        },
        {
            title: 'Events',
            link: '/events',
        },
        {
            title: 'Webinars',
            link: '/webinars',
        },
        {
            title: 'Prices',
            link: '/prices',
        },
        {
            title: 'Research',
            link: 'https://blockworksresearch.com',
            target: '_blank',
        },
    ];

    return (
        <main className="p-12 border-b xl:border-none w-full">
            <Breadcrumb
                items={[
                    {
                        title: 'Site Map',
                        link: '/sitemap',
                    },
                ]}
            />
            <div>
                <h1 className="self-stretch w-full text-5xl font-semibold text-left text-[#110b29]">Sitemap</h1>
                <p className="self-stretch w-full text-xl text-left text-[#110b29]"></p>
            </div>
            <div className="mt-12 grid gap-8 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
                <SitemapContainer title="Sections">
                    <ul className="p-0 m-0">
                        {sections.map(section => (
                            <SitemapListItem key={section.link} link={section.link} target={section.target || ''}>
                                {section.title}
                            </SitemapListItem>
                        ))}
                    </ul>
                </SitemapContainer>
                {podcasts && podcasts.length > 0 && (
                    <SitemapContainer title="Podcasts">
                        <ul className="p-0 m-0">
                            {podcasts.map(podcast => (
                                <SitemapListItem key={podcast.slug} link={`/podcast/${podcast.slug}`}>
                                    {podcast.title}
                                </SitemapListItem>
                            ))}
                        </ul>
                    </SitemapContainer>
                )}

                {categories && categories.length > 0 && (
                    <SitemapContainer title="News">
                        <ul className="p-0 m-0">
                            <li className="pb-3">
                                <p>By Category</p>
                            </li>
                            <li>
                                <ul className="pl-4 m-0">
                                    {categories.map(category => (
                                        <SitemapListItem key={category.slug} link={`/category/${category.slug}`}>
                                            {category.name}
                                        </SitemapListItem>
                                    ))}
                                </ul>
                            </li>
                            <SitemapListItem link="/news">News Archive</SitemapListItem>
                            <SitemapListItem link="/sitemap/categories">All Categories</SitemapListItem>
                            <SitemapListItem link="/sitemap/tags">All Tags</SitemapListItem>
                            <SitemapListItem link="/sitemap/authors">All Authors</SitemapListItem>
                        </ul>
                    </SitemapContainer>
                )}
                <SitemapContainer title="Newsletters">
                    <ul className="p-0 m-0">
                        <SitemapListItem link="/newsletter/daily">Blockworks Daily</SitemapListItem>
                        <SitemapListItem link="/newsletter/research">Research Daily Debrief</SitemapListItem>
                    </ul>
                </SitemapContainer>
                <SitemapContainer title="More Information">
                    <ul className="p-0 m-0">
                        <SitemapListItem link="/about">About</SitemapListItem>
                        <SitemapListItem link="/careers">
                            <>
                                Careers
                                <span className="ml-2 px-2 text-sm py-0.5 rounded text-white bg-primary">Join us!</span>
                            </>
                        </SitemapListItem>
                        <SitemapListItem link="/clients">Clients</SitemapListItem>
                        <SitemapListItem link="/financial-disclosures">Financial Disclosure</SitemapListItem>
                        <SitemapListItem link="/privacy-policy">Terms</SitemapListItem>
                        <SitemapListItem link="/contact-us">Contact</SitemapListItem>
                    </ul>
                </SitemapContainer>
                <SitemapContainer title="Prices">
                    <ul className="p-0 m-0">
                        <SitemapListItem link="/prices">Today&apos;s Crypto Prices</SitemapListItem>
                    </ul>
                </SitemapContainer>
            </div>
        </main>
    );
};

export default SitemapPageLayout;
